import type { SectionCollapseStates } from './hooks/useSectionCollapseStates';

export const SECTION_IDS = {
  basicInfo: 'basic-info',
  applicationContent: 'application-content',
  transactionsDetail: 'transactions-detail',
  journalInfo: 'journal-info',
} as const;

export const DEFAULT_SECTION_STATES: SectionCollapseStates = {
  [SECTION_IDS.basicInfo]: false,
  [SECTION_IDS.applicationContent]: false,
  [SECTION_IDS.transactionsDetail]: false,
  [SECTION_IDS.journalInfo]: false,
};
